import * as API from '../api'
export const FETCH_INITIAL_STATE = 'FETCH_INITIAL_STATE'

export const FETCH_CONSUMPTION_MAP = 'FETCH_CONSUMPTION_MAP'
export const FETCHING_CONSUMPTION_MAP = 'FETCHING_CONSUMPTION_MAP'
export const FETCH_CONSUMPTION_MAP_ERROR = 'FETCH_CONSUMPTION_MAP_ERROR'

export const FETCH_CONSUMPTION_MAP_ITEM = 'FETCH_CONSUMPTION_MAP_ITEM'
export const FETCHING_CONSUMPTION_MAP_ITEM = 'FETCHING_CONSUMPTION_MAP_ITEM'
export const FETCH_CONSUMPTION_MAP_ITEM_ERROR = 'FETCH_CONSUMPTION_MAP_ITEM__ERROR'

export const FETCHING_YEAR_LIST = 'FETCHING_YEAR_LIST'
export const FETCH_YEAR_LIST = 'FETCH_YEAR_LIST'
export const FETCH_YEAR_LIST_ERROR = 'FETCH_YEAR_LIST_ERROR'

export const FETCHING_CONSUMPTION_MAP_AREAS = 'FETCHING_CONSUMPTION_MAP_AREAS'
export const FETCH_CONSUMPTION_MAP_AREAS = 'FETCH_CONSUMPTION_MAP_AREAS'
export const FETCH_CONSUMPTION_MAP_AREAS_ERROR = 'FETCH_CONSUMPTION_MAP_AREAS_ERROR'

export const CLEAN_YEAR = 'CLEAN_YEAR'
export const CHANGE_YEAR = 'CHANGE_YEAR'
export const CHANGE_AREA = 'CHANGE_AREA'

export const fetchInitialState = () => {
  return dispatch => {
    dispatch({ type: FETCH_INITIAL_STATE, value: false })
  }
}
export const fetchCleanYear = () => {
  return dispatch => {
    dispatch({ type: CLEAN_YEAR, value: false })
  }
}
export const fetchConsumptionMap = ( year, areaId ) => {
  return dispatch => {
    dispatch({ type: FETCHING_CONSUMPTION_MAP, value: true })

    return API.consumptionMap
      .getConsumptionMap({ year, areaId })
      .then(({ data = {} }) => {
        const { items, last_update } = data

        const months = [
          '',
          'jan',
          'fev',
          'mar',
          'abr',
          'mai',
          'jun',
          'jul',
          'ago',
          'set',
          'out',
          'nov',
          'dez'
        ]

        const consumptionMap = items.reduce((columns, item) => {
          const { responsible_name, maps = [] } = item
          const column = { responsible_name }

          for (let mapItem of maps) {
            const month = Number(mapItem.competence)
            column[months[month]] = mapItem
            delete column.competence
          }

          return [...columns, column]
        }, [])

        dispatch({ type: FETCH_CONSUMPTION_MAP, last_update: last_update, items: consumptionMap })
      })
      .catch(err => {
        dispatch({ type: FETCH_CONSUMPTION_MAP_ERROR })
      })
  }
}

export const fetchConsumptionMapItem = id => {
  return dispatch => {
    dispatch({ type: FETCHING_CONSUMPTION_MAP_ITEM, value: true })

    return API.consumptionMap
      .getConsumptionMapItem(id)
      .then(({ data = {} }) => {
        dispatch({ type: FETCH_CONSUMPTION_MAP_ITEM, item: data })
      })
      .catch(err => {
        dispatch({ type: FETCH_CONSUMPTION_MAP_ITEM_ERROR })
      })
  }
}

export const fetchYearList = (areaId) => {
  return dispatch => {
    dispatch({ type: FETCHING_YEAR_LIST, value: true })

    return API.consumptionMap
      .getYearList(areaId)
      .then(({ data = {} }) => {
        const { years = [] } = data

        const yearsList = years.map(item => {
          return { label: item, value: item }
        })

        dispatch({ type: FETCH_YEAR_LIST, items: yearsList })
      })
      .catch(err => {
        dispatch({ type: FETCH_YEAR_LIST_ERROR })
      })
  }
}

export const fetchAreaList = () => {
  return dispatch => {
    dispatch({ type: FETCHING_CONSUMPTION_MAP_AREAS, value: true })

    return API.consumptionMap
      .getAreaList()
      .then(({ data = {} }) => {
        const { areas = [] } = data

        const areasList = areas.map(item => {
          return { label: item.name, value: item.id }
        })

        dispatch({ type: FETCH_CONSUMPTION_MAP_AREAS, items: areasList })
      })
      .catch(err => {
        dispatch({ type: FETCH_CONSUMPTION_MAP_AREAS_ERROR })
      })
  }
}

export const changeYear = ({ value }) => {
  return dispatch => {
    return dispatch({ type: CHANGE_YEAR, value })
  }
}

export const changeArea = value => {
  return dispatch => {
    return dispatch({ type: CHANGE_AREA, value })
  }
}



// WEBPACK FOOTER //
// ./src/actions/consumptionMap.js